/**
 * Created by anatoly on 01.06.2026
 */

Placements.ENTRIES["newLevelsExplanation"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,
    priority: 100,
    filter: function () {
        return NewLevelsWindow.canShow();
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "newLevelsExplanation",
            action: function (f) {
                new NewLevelsWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
